export function focusNextDOMElement(e: KeyboardEvent, selector: string) {
    const nextElement = document.querySelector(selector) as HTMLElement
    e.preventDefault()
    nextElement?.focus()
}
